import { render, staticRenderFns } from "./DenemeSeneme.vue?vue&type=template&id=09164c4c&"
import script from "./DenemeSeneme.vue?vue&type=script&lang=js&"
export * from "./DenemeSeneme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports